import { MyReviewItem, ReviewCandidate } from 'global/definitions'

export const isReview = (object: MyReviewItem | ReviewCandidate): object is MyReviewItem => {
	return 'review' in object
}
